import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../actions/searchActions";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Media
} from "reactstrap";
import { checkAllAggregations } from "../actions/searchActions";

import dropdownDownImg from "../images/dropdownDown.png";
import filterImg from "../images/filter.png";
import checkboxNotSelected from "../images/checkboxNotSelected.png";
import checkboxSelected from "../images/checkboxSelected.png";

import classes from "./ChaptersSort.module.scss";
import AggregationsCubes from "./Aggregations/AggregationsCubes";

class ChaptersSort extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chaptersModalIsOpen: false,
      aggregations: this.props.aggregations,
      allChecked: false,
      selectedAggregations: 0
    };

    this.chaptersModalToggle = this.chaptersModalToggle.bind(this);
    this.checkUnCheckClicked = this.checkUnCheckClicked.bind(this);
  }

  chaptersModalToggle() {
    this.setState({
      chaptersModalIsOpen: !this.state.chaptersModalIsOpen
    });
  }

  checkUnCheckClicked() {
    const toCheck = !this.state.allChecked;
    this.setState({
      allChecked: toCheck
    });
    this.props.checkAllClick(toCheck);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.aggregations) {
      this.setState({ aggregations: nextProps.aggregations });
    }
    if (nextProps.selectedAggregations >= 0) {
      this.setState({ selectedAggregations: nextProps.selectedAggregations });
    }
  }

  render() {
    return (
      <div>
        <Button
          color="light"
          onClick={this.chaptersModalToggle}
          className={classes.sortButton}
        >
          <span>
            {this.state.selectedAggregations === 0
              ? "לא נבחרו פרקים"
              : "נבחרו " + this.state.selectedAggregations + " פרקים"}{" "}
          </span>
          <Media
            src={dropdownDownImg}
            alt="בחר פרקים"
            className={classes.sortImg}
          />
        </Button>
        {this.state.aggregations && this.state.aggregations.length > 0 ? (
          <Modal
            isOpen={this.state.chaptersModalIsOpen}
            toggle={this.chaptersModalToggle}
            className={classes.chaptersModal}
            fade={false}
          >
            <ModalHeader>
              <Button color="link" onClick={() => this.checkUnCheckClicked()}>
                <Media
                  src={
                    this.state.allChecked
                      ? checkboxSelected
                      : checkboxNotSelected
                  }
                  alt="בחר את כל הפרקים"
                />
              </Button>
              <span className={classes.selectAllSpan}>בחר את כל הפרקים</span>
            </ModalHeader>
            <ModalBody>
              <AggregationsCubes aggregations={this.state.aggregations} />
            </ModalBody>
            <ModalFooter className={classes.modalFooter}>
              <Button
                color="primary"
                className={classes.sortModalButton}
                onClick={this.chaptersModalToggle}
              >
                <Media
                  object
                  src={filterImg}
                  alt="סנן"
                  className={classes.filterImg}
                />
                <span>סנן</span>
              </Button>
            </ModalFooter>
          </Modal>
        ) : (
          <Modal
            isOpen={this.state.chaptersModalIsOpen}
            toggle={this.chaptersModalToggle}
            className={classes.chaptersModalNoChapter}
            fade={false}
          >
            <ModalBody>אין פרקים</ModalBody>
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    aggregations: state.searchData.aggregations,
    selectedAggregations: state.searchData.selectedAggregations
  };
};

const mapDispatchToProps = dispatch => {
  return {
    searchHandler: () => dispatch(actions.search()),
    clearAndSearchHandler: () => dispatch(actions.clearDataAndSearch()),
    checkAllClick: checkAll => dispatch(checkAllAggregations(checkAll))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChaptersSort);
